import React from "react";

export const defaultsections = [
  {
    group: "Employees",
    type: "Permanent",
    current_total: "",
    current_equal_min: "",
    current_percent_equal: "",
    current_more_min: "",
    current_percent_more: "",
    prev_total: "",
    prev_equal_min: "",
    prev_percent_equal: "",
    prev_more_min: "",
    prev_percent_more: "",
  },
  {
    group: "Employees",
    type: "Male",
    current_total: "",
    current_equal_min: "",
    current_percent_equal: "",
    current_more_min: "",
    current_percent_more: "",
    prev_total: "",
    prev_equal_min: "",
    prev_percent_equal: "",
    prev_more_min: "",
    prev_percent_more: "",
  },
  {
    group: "Employees",
    type: "Female",
    current_total: "",
    current_equal_min: "",
    current_percent_equal: "",
    current_more_min: "",
    current_percent_more: "",
    prev_total: "",
    prev_equal_min: "",
    prev_percent_equal: "",
    prev_more_min: "",
    prev_percent_more: "",
  },
  {
    group: "Employees",
    type: "Other than Permanent",
    current_total: "",
    current_equal_min: "",
    current_percent_equal: "",
    current_more_min: "",
    current_percent_more: "",
    prev_total: "",
    prev_equal_min: "",
    prev_percent_equal: "",
    prev_more_min: "",
    prev_percent_more: "",
  },
  {
    group: "Workers",
    type: "Permanent",
    current_total: "",
    current_equal_min: "",
    current_percent_equal: "",
    current_more_min: "",
    current_percent_more: "",
    prev_total: "",
    prev_equal_min: "",
    prev_percent_equal: "",
    prev_more_min: "",
    prev_percent_more: "",
  },
  {
    group: "Workers",
    type: "Male",
    current_total: "",
    current_equal_min: "",
    current_percent_equal: "",
    current_more_min: "",
    current_percent_more: "",
    prev_total: "",
    prev_equal_min: "",
    prev_percent_equal: "",
    prev_more_min: "",
    prev_percent_more: "",
  },
  {
    group: "Workers",
    type: "Female",
    current_total: "",
    current_equal_min: "",
    current_percent_equal: "",
    current_more_min: "",
    current_percent_more: "",
    prev_total: "",
    prev_equal_min: "",
    prev_percent_equal: "",
    prev_more_min: "",
    prev_percent_more: "",
  },
  {
    group: "Workers",
    type: "Other than Permanent",
    current_total: "",
    current_equal_min: "",
    current_percent_equal: "",
    current_more_min: "",
    current_percent_more: "",
    prev_total: "",
    prev_equal_min: "",
    prev_percent_equal: "",
    prev_more_min: "",
    prev_percent_more: "",
  },
];

const WageDistributionTable = ({ wageData, setWageData }) => {
  // Use the wageData if provided and non-empty; otherwise fall back to defaultsections.
  const rows =
    Array.isArray(wageData) && wageData.length > 0 ? wageData : defaultsections;

  // Update field value in the array at the specified index.
  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setWageData(updated);
  };

  // Render each row in the table.
  const renderRow = (row, index) => {
    // Since no gender field is needed, label is simply the type.
    const label = row.type;
    return (
      <tr key={`${row.group}-${label}`}>
        <td style={leftCellStyle}>{label}</td>
        {[
          "current_total",
          "current_equal_min",
          "current_percent_equal",
          "current_more_min",
          "current_percent_more",
          "prev_total",
          "prev_equal_min",
          "prev_percent_equal",
          "prev_more_min",
          "prev_percent_more",
        ].map((field) => (
          <td key={field} style={cellStyle}>
            <input
              type="text"
              value={row[field]}
              onChange={(e) => handleChange(index, field, e.target.value)}
              placeholder="Enter"
              style={inputStyle}
            />
          </td>
        ))}
      </tr>
    );
  };

  return (
    <div
      style={{
        marginTop: 20,
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="3" style={headerStyle}>
              Category
            </th>
            <th colSpan="5" style={headerStyle}>
              FY ____ <br /> Current Financial Year
            </th>
            <th colSpan="5" style={headerStyle}>
              FY ____ <br /> Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={headerStyle}>
              Total (A)
            </th>
            <th colSpan="2" style={headerStyle}>
              Equal to Min Wage
            </th>
            <th colSpan="2" style={headerStyle}>
              More than Min Wage
            </th>
            <th rowSpan="2" style={headerStyle}>
              Total (D)
            </th>
            <th colSpan="2" style={headerStyle}>
              Equal to Min Wage
            </th>
            <th colSpan="2" style={headerStyle}>
              More than Min Wage
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}>No. (B)</th>
            <th style={headerStyle}>% (B/A)</th>
            <th style={headerStyle}>No. (C)</th>
            <th style={headerStyle}>% (C/A)</th>
            <th style={headerStyle}>No. (E)</th>
            <th style={headerStyle}>% (E/D)</th>
            <th style={headerStyle}>No. (F)</th>
            <th style={headerStyle}>% (F/D)</th>
          </tr>
        </thead>
        <tbody>
          {["Employees", "Workers"].map((group) => (
            <React.Fragment key={group}>
              <tr>
                <td colSpan="11" style={sectionHeaderStyle}>
                  <div style={{ textAlign: "center" }}>{group}</div>
                </td>
              </tr>
              {rows
                .map((row, i) => ({ ...row, index: i }))
                .filter((r) => r.group === group)
                .map((row) => renderRow(row, row.index))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid black",
  textAlign: "center",
  width: "9.09%",
};

const sectionHeaderStyle = {
  padding: "10px",
  backgroundColor: "#D3C9CE",
  fontWeight: "bold",
  border: "1px solid black",
};

const leftCellStyle = {
  padding: "10px",
  border: "1px solid black",
  backgroundColor: "#F0E9EC",
  fontWeight: "bold",
  textAlign: "left",
  width: "9.09%",
};

const cellStyle = {
  padding: "8px",
  border: "1px solid black",
  textAlign: "center",
  width: "9.09%",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
};

export default WageDistributionTable;
